import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { Box } from "@mui/material";
import { useAccountingContext } from "../../AccountingProvider";
import { AccountingListActionMenu } from "../AccountingListActionMenu/AccountingListActionMenu";

export const PreBillActions = memo((props) => {
  const { classes, theme } = useStyles();
  const { navigate } = useRouter();
  const { actionMenuRef } = useAccountingContext();

  const handleNavigateToReconcile = () => {
    navigate(`/accounting/invoices/${props.id}/pre-bill`);
  };

  return (
    <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
      <Box className={classes.actionContainer}>
        <MiButton
          title="Pre-Bill"
          variant={BUTTON_VARIANTS.CONTAINED}
          onClick={handleNavigateToReconcile}
          sx={{ marginRight: theme.spacing(2) }}
        />

        <AccountingListActionMenu
          ref={actionMenuRef}
          menuViewConfig={{
            forceCloseOut: false,
            orderActivityDetails: true,
          }}
          {...props}
        />
      </Box>
    </Box>
  );
});

const useStyles = makeStyles()((theme) => ({
  actionContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("xl")]: {
      justifyContent: "space-between",
    },
  },
}));
